import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Home } from 'lucide-react';
import SEO from '@/components/SEO';

const TermsOfService = () => {
  const navigate = useNavigate();

  return (
    <>
      <SEO 
        title="Terms of Service - Debatefy"
        description="Terms of Service for Debatefy.online"
        canonical="https://debatefy.online/terms-of-service"
      />
      <div className="feature-detail-page">
        <div className="feature-detail-container">
          <div className="feature-detail-header">
            <Button
              variant="outline"
              onClick={() => navigate('/')}
              className="home-button"
            >
              <Home className="mr-2 h-4 w-4" />
              Home
            </Button>
          </div>

          <Card className="feature-detail-card">
            <CardContent className="feature-detail-content">
              <div className="content-text">
                <h1>Terms of Service</h1>
                <p className="text-sm text-muted-foreground">Last updated: January 2026</p>

                <h2>1. Acceptance of Terms</h2>
                <p>
                  By accessing and using Debatefy, you accept and agree to be bound by the terms
                  and provisions of this agreement. If you do not agree to these terms, please do not use our service.
                </p>

                <h2>2. Description of Service</h2>
                <p>
                  Debatefy is an AI-moderated debate platform that enables structured, fact-based discussions
                  between participants. Our service includes:
                </p>
                <ul>
                  <li>AI-powered moderation and scoring</li>
                  <li>Real-time fact-checking via Perplexity AI</li>
                  <li>Debate recording and archiving</li>
                  <li>Multi-language support</li>
                </ul>

                <h2>3. User Accounts</h2>
                <p>To use certain features, you may need to create an account. You are responsible for:</p>
                <ul>
                  <li>Maintaining the confidentiality of your account credentials</li>
                  <li>All activities that occur under your account</li>
                  <li>Notifying us immediately of any unauthorized use</li>
                </ul>

                <h2>4. Acceptable Use</h2>
                <p>You agree NOT to use the service to:</p>
                <ul>
                  <li>Post false, misleading, or defamatory content</li>
                  <li>Harass, abuse, or harm other users</li>
                  <li>Violate any applicable laws or regulations</li>
                  <li>Attempt to interfere with the proper functioning of the platform</li>
                  <li>Use automated systems to access the service</li>
                </ul>

                <h2>5. Content Ownership</h2>
                <p>
                  You retain ownership of the content you post. However, by posting content on Debatefy,
                  you grant us a non-exclusive, worldwide license to use, display, and distribute your content
                  as part of the service.
                </p>

                <h2>6. AI-Generated Content</h2>
                <p>
                  Our platform uses AI for moderation, fact-checking, and scoring. While we strive for accuracy,
                  AI-generated content may contain errors. Users should verify important information independently.
                </p>

                <h2>7. Payment Terms</h2>
                <p>
                  Paid features are subject to the pricing displayed at the time of purchase.
                  Payments are processed securely through Stripe or PayPal. Subscriptions may be cancelled at any time.
                </p>

                <h2>8. Termination</h2>
                <p>
                  We reserve the right to suspend or terminate your account if you violate these terms
                  or engage in behavior that we deem harmful to the platform or other users.
                </p>

                <h2>9. Limitation of Liability</h2>
                <p>
                  Debatefy is provided "as is" without warranties of any kind. We are not liable for any
                  damages arising from your use of the service.
                </p>

                <h2>10. Changes to Terms</h2>
                <p>
                  We may modify these terms at any time. Continued use of the service after changes
                  constitutes acceptance of the new terms.
                </p>

                <h2>11. Contact</h2>
                <p>
                  For questions about these Terms of Service, please contact us through the Admin Panel.
                </p>

                <p className="text-sm text-muted-foreground mt-8">
                  © 2025 Debatefy.online
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </>
  );
};

export default TermsOfService;
